import React from "react";
import { makeStyles } from '@material-ui/core/styles';
import EditIcon from '@material-ui/icons/Edit';
import { Grid } from "@material-ui/core";
import showStatusKode from "./showStatusKode";
import FeaturetypeModal from './FeaturetypeModal'
import ModalButton from './ModalButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import DeleteIcon from '@material-ui/icons/Delete';
import { useCardStyles } from '../styles/commonStyles';

function getFilteredFeaures(featureTypes, ds_id) {
    const result = featureTypes.filter((f) => { return f.ds_id === ds_id });
    return result.length == 0 ? featureTypes : result;
}

export default function FeatureTypeTable(props) {
    const classes = useCardStyles();
    return (
        <Table size="small" className={classes.table} aria-label="featuretype-table" >
            <TableHead>
                <TableRow>
                    <TableCell>Alias</TableCell>
                    <TableCell align="center">Interesseområde</TableCell>
                    <TableCell align="center">Udtages til manuel behandling</TableCell>
                    <TableCell align="center">Status</TableCell>
                    <TableCell align="center">Actions</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {getFilteredFeaures(props.featuretypes, props.ds_id).map(row => (
                    <TableRow key={row.ft_id}>
                        {row.active ? (
                            <>
                                <TableCell component="th" scope="row">{row.alias}</TableCell>
                                <TableCell align="center">{row.is_interesse ? 'X' : ''}</TableCell>
                                <TableCell align="center">{row.is_manuel ? 'X' : ''}</TableCell>
                                <TableCell align="center">{showStatusKode(row.status_code, row.status_message, row.status_time)}</TableCell>
                                <TableCell align="center">
                                    <Grid
                                        container
                                        style={{ width: 166 }}
                                        direction="row"
                                        alignItems="flex-start"
                                        justifyContent="center">
                                        <Grid item>
                                            <FeaturetypeModal
                                                color="default"
                                                id={row.ft_id}
                                                values={row}
                                                sources={props.sources}
                                                cancelText="Annuller"
                                                info = {row.status_message +" " + row.status_time}
                                                titleText="Ret featuretype"
                                                acceptText="Ret"
                                                acceptAction={props.edit}
                                                btnText={<EditIcon />}
                                            />
                                        </Grid>
                                        <Grid item>
                                            <ModalButton
                                                btnColor="default"
                                                id={row.ft_id}
                                                btnText={<DeleteIcon />}
                                                acceptAction={() => { props.delete(row.ft_id) }}
                                                acceptText="slet"
                                                cancelText="fortryd"
                                                titleText={"Bekræft sletning af datakilden: " + row.alias}
                                                contentText={"Denne handling fjerner datakilden: '" + row.alias + "' tilhørende " + props.vendorMeta.vendor_alias + " uden yderligere varsel. Der vil ikke blive hentet data fra nogen featuretypes der er koblet til denne kilde."}
                                            />
                                        </Grid>
                                    </Grid>
                                </TableCell>
                            </>
                        ) : (
                            <>
                                <TableCell className={classes.notactive} component="th" scope="row">{row.alias}</TableCell>
                                <TableCell className={classes.notactive} align="center">{row.is_interesse ? '✓' : ''}</TableCell>
                                <TableCell className={classes.notactive} align="center">{row.is_manuel ? '✓' : ''}</TableCell>
                                <TableCell className={classes.notactive} align="center">{showStatusKode(row.status_code, row.status_message, row.status_time)}</TableCell>
                                <TableCell className={classes.notactive} align="center">
                                    <Grid
                                        container
                                        style={{ width: 166 }}
                                        direction="row"
                                        alignItems="flex-start"
                                        justifyContent="center">
                                        <Grid item>
                                            <FeaturetypeModal
                                                key={row.ft_id}
                                                color="default"
                                                id={row.ft_id}
                                                values={row}
                                                info = {showStatusKode(row.status_code, row.status_message, row.status_time)}
                                                sources={props.sources}
                                                cancelText="Annuller"
                                                titleText="Ret featuretype"
                                                acceptText="Ret"
                                                acceptAction={props.edit}
                                                btnText={<EditIcon />}
                                            />
                                        </Grid>
                                        <Grid item>
                                            <ModalButton
                                                key={row.ft_id}
                                                btnColor="default"
                                                id={row.ft_id}
                                                btnText={<DeleteIcon />}
                                                acceptAction={() => { props.delete(row.ft_id) }}
                                                acceptText="slet"
                                                cancelText="fortryd"
                                                titleText={"Bekræft sletning af datakilden: " + row.alias}
                                                contentText={"Denne handling fjerner datakilden: '" + row.alias + "' tilhørende " + props.vendorMeta.vendor_alias + " uden yderligere varsel. Der vil ikke blive hentet data fra nogen featuretypes der er koblet til denne kilde."}
                                            />
                                        </Grid>
                                    </Grid>
                                </TableCell>
                            </>
                        )}
                    </TableRow>
                ))}
            </TableBody>
        </Table >
    );
}